<template>
  <span v-if="source.url" class="source-list-item">
    {{ source.sourceName }}{{ ' ' }}
    <a :href="source.url" class="text-purple no-underline" target="_blank" rel="noopener noreferrer"
      >» Besök källa</a
    >
  </span>
  <span v-else class="source-list-item">{{ source.sourceName }}</span>
</template>

<script lang="ts" setup>
interface SourceField {
  sourceName: string
  url?: string
}

interface Props {
  source: SourceField
}

const props = defineProps<Props>()
</script>
